import React, { useState, useEffect } from "react";
import styles from "./Pricing.module.css";
import Navbar from "../../components/Navbar/Navbar";
import PricingPlanCard from "../../components/PricingPlanCard/PricingPlanCard";
import { PricingCard } from "../../components/PricingCard/PricingCard";
import star from "../../assets/star.svg";
import diagonalArrow from "../../assets/diagonalArrow.svg";
import topTrustpilotStar from "../../assets/topTrustpilotStar.svg";
import bottomTrustpilotStar from "../../assets/bottomTrustpilotStar.svg";
import googleLogo from "../../assets/googleLogo.svg";
import googleStar from "../../assets/googleStar.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CookiePopup from "../../components/CookiePopup/CookiePopup";
import SubtitleTemplate from "../../components/SubtitleTemplate/SubtitleTemplate";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import { ReactComponent as Included } from "../../assets/includedIcon.svg";
import { ReactComponent as NotIncluded } from "../../assets/notIncludedIcon.svg";
import { ReactComponent as CheckCircleFeatures } from "../../assets/checkCircleFeatures.svg";
import { ReactComponent as ArrowDiagonalGreen } from "../../assets/diagonalArrowGreen.svg";
import { ReactComponent as ArrowDiagonalWhite } from "../../assets/diagonalArrowWhite.svg";
import BillingSlider from "../../components/BillingSlider/BillingSlider";
import FooterLanding from "../../components/FooterLanding/FooterLanding";
const Pricing = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(["pricingCard","Landing"]);
  const [sliderValue, setSliderValue] = useState(10);
  const [selectedCard, setSelectedCard] = useState(0);
  const [currentPlan, setCurrentPlan] = useState({
    documents: "+100.000 Documentos",
    price: "0,05",
  });



  const plansData = [
    {
      title: "Free",
      features: [
        t('features_free1'),
        t('features_free2'),
        t('features_free3'),
        t('features_free4'),

      ],
      pricing: t('features_free_Pricing'),
    },
    {
      title: "Plus",
      features: [
        t('features_plus1'),
        t('features_plus2'),
        t('features_plus3'),
        t('features_plus4'),
      ],
      pricing: t('features_plus_Pricing'),
    },
    {
      title: "Pro",
      features: [
        t('features_pro1'),
        t('features_pro2'),
        t('features_pro3'),
        t('features_pro4'),
        t('features_pro5'),
      ],
      pricing: t('features_pro_Pricing'),
    },
    {
      title: "Enterprise",
      features: [
        t('features_enterprise1'),
        t('features_enterprise2'),
        t('features_enterprise3'),
        t('features_enterprise4'),
        t('features_enterprise5'),
      ],
      pricing: t('features_enterprise_Pricing'),
    },
    {
      title: "Custom",
      features: [
        t('features_custom1'),
        t('features_custom2'),
        t('features_custom3'),
      ],
      pricing: t('features_custom_Pricing'),
      buttonType: true,
    },
  ];

  const benefits = [
    {
      name: t("documents"),
      basic: t("basic_documents"),
      standard: t("standard_documents"),
      pro: t("pro_documents"),
      enterprise: t("enterprise_documents"),
    },
    {
      name: t("contact_creation"),
      basic: t("basic_contacts"),
      standard: t("standard_contacts"),
      pro: t("pro_contacts"),
      enterprise: t("enterprise_contacts"),
    },
    {
      name: t("asset_management"),
      basic: t("basic_assets"),
      standard: t("standard_assets"),
      pro: t("pro_assets"),
      enterprise: t("enterprise_assets"),
    },
    {
      name: t("chat_responses"),
      basic: t("basic_chat_responses"),
      standard: t("standard_chat_responses"),
      pro: t("pro_chat_responses"),
      enterprise: t("enterprise_chat_responses"),
    },
    {
      name: t("currencies"),
      basic: t("basic_currencies"),
      standard: t("standard_currencies"),
      pro: t("pro_currencies"),
      enterprise: t("enterprise_currencies"),
    },
    {
      name: t("invoice_access"),
      basic: t("basic_invoice_access"),
      standard: t("standard_invoice_access"),
      pro: t("pro_invoice_access"),
      enterprise: t("enterprise_invoice_access"),
    },
    {
      name: t("daily_backups"),
      basic: t("basic_daily_backups"),
      standard: t("standard_daily_backups"),
      pro: t("pro_daily_backups"),
      enterprise: t("enterprise_daily_backups"),
    },
    {
      name: t("unlimited_storage"),
      basic: t("basic_unlimited_storage"),
      standard: t("standard_unlimited_storage"),
      pro: t("pro_unlimited_storage"),
      enterprise: t("enterprise_unlimited_storage"),
    },
    {
      name: t("real_time_access"),
      basic: t("basic_real_time_access"),
      standard: t("standard_real_time_access"),
      pro: t("pro_real_time_access"),
      enterprise: t("enterprise_real_time_access"),
    },
    {
      name: t("advanced_document_search"),
      basic: t("basic_advanced_document_search"),
      standard: t("standard_advanced_document_search"),
      pro: t("pro_advanced_document_search"),
      enterprise: t("enterprise_advanced_document_search"),
    },
    {
      name: t("quote_to_invoice_conversion"),
      basic: t("basic_quote_to_invoice_conversion"),
      standard: t("standard_quote_to_invoice_conversion"),
      pro: t("pro_quote_to_invoice_conversion"),
      enterprise: t("enterprise_quote_to_invoice_conversion"),
    },
    {
      name: t("bank_integration"),
      basic: t("basic_bank_integration"),
      standard: t("standard_bank_integration"),
      pro: t("pro_bank_integration"),
      enterprise: t("enterprise_bank_integration"),
    },
    {
      name: t("pdf_invoice_signing"),
      basic: t("basic_pdf_invoice_signing"),
      standard: t("standard_pdf_invoice_signing"),
      pro: t("pro_pdf_invoice_signing"),
      enterprise: t("enterprise_pdf_invoice_signing"),
    },
    {
      name: t("qr_code"),
      basic: t("basic_qr_code"),
      standard: t("standard_qr_code"),
      pro: t("pro_qr_code"),
      enterprise: t("enterprise_qr_code"),
    },
    {
      name: t("invoice_status_control"),
      basic: t("basic_invoice_status_control"),
      standard: t("standard_invoice_status_control"),
      pro: t("pro_invoice_status_control"),
      enterprise: t("enterprise_invoice_status_control"),
    },
    {
      name: t("unlimited_invoice_sending"),
      basic: t("basic_unlimited_invoice_sending"),
      standard: t("standard_unlimited_invoice_sending"),
      pro: t("pro_unlimited_invoice_sending"),
      enterprise: t("enterprise_unlimited_invoice_sending"),
    },
    {
      name: t("invoice_import"),
      basic: t("basic_invoice_import"),
      standard: t("standard_invoice_import"),
      pro: t("pro_invoice_import"),
      enterprise: t("enterprise_invoice_import"),
    },
    {
      name: t("data_export"),
      basic: t("basic_data_export"),
      standard: t("standard_data_export"),
      pro: t("pro_data_export"),
      enterprise: t("enterprise_data_export"),
    },
    {
      name: t("invoice_print_and_email"),
      basic: t("basic_invoice_print_and_email"),
      standard: t("standard_invoice_print_and_email"),
      pro: t("pro_invoice_print_and_email"),
      enterprise: t("enterprise_invoice_print_and_email"),
    },
    {
      name: t("invoice_attachments"),
      basic: t("basic_invoice_attachments"),
      standard: t("standard_invoice_attachments"),
      pro: t("pro_invoice_attachments"),
      enterprise: t("enterprise_invoice_attachments"),
    },
    {
      name: t("sepa_receipts"),
      basic: t("basic_sepa_receipts"),
      standard: t("standard_sepa_receipts"),
      pro: t("pro_sepa_receipts"),
      enterprise: t("enterprise_sepa_receipts"),
    },
    {
      name: t("income_and_costs"),
      basic: t("basic_income_and_costs"),
      standard: t("standard_income_and_costs"),
      pro: t("pro_income_and_costs"),
      enterprise: t("enterprise_income_and_costs"),
    },
    {
      name: t("vat_management"),
      basic: t("basic_vat_management"),
      standard: t("standard_vat_management"),
      pro: t("pro_vat_management"),
      enterprise: t("enterprise_vat_management"),
    },
    {
      name: t("automatic_invoice_submission"),
      basic: t("basic_automatic_invoice_submission"),
      standard: t("standard_automatic_invoice_submission"),
      pro: t("pro_automatic_invoice_submission"),
      enterprise: t("enterprise_automatic_invoice_submission"),
    },
    {
      name: t("discount_management"),
      basic: t("basic_discount_management"),
      standard: t("standard_discount_management"),
      pro: t("pro_discount_management"),
      enterprise: t("enterprise_discount_management"),
    },
    {
      name: t("bulk_upload"),
      basic: t("basic_bulk_upload"),
      standard: t("standard_bulk_upload"),
      pro: t("pro_bulk_upload"),
      enterprise: t("enterprise_bulk_upload"),
    },
    {
      name: t("multiple_addresses"),
      basic: t("basic_multiple_addresses"),
      standard: t("standard_multiple_addresses"),
      pro: t("pro_multiple_addresses"),
      enterprise: t("enterprise_multiple_addresses"),
    },
    {
      name: t("alerts_and_notifications"),
      basic: t("basic_alerts_and_notifications"),
      standard: t("standard_alerts_and_notifications"),
      pro: t("pro_alerts_and_notifications"),
      enterprise: t("enterprise_alerts_and_notifications"),
    },
    {
      name: t("comparative_analysis"),
      basic: t("basic_comparative_analysis"),
      standard: t("standard_comparative_analysis"),
      pro: t("pro_comparative_analysis"),
      enterprise: t("enterprise_comparative_analysis"),
    },
    {
      name: t("cash_flow_analysis"),
      basic: t("basic_cash_flow_analysis"),
      standard: t("standard_cash_flow_analysis"),
      pro: t("pro_cash_flow_analysis"),
      enterprise: t("enterprise_cash_flow_analysis"),
    },
    {
      name: t("billing_analysis"),
      basic: t("basic_billing_analysis"),
      standard: t("standard_billing_analysis"),
      pro: t("pro_billing_analysis"),
      enterprise: t("enterprise_billing_analysis"),
    },
    {
      name: t("warehouse_management"),
      basic: t("basic_warehouse_management"),
      standard: t("standard_warehouse_management"),
      pro: t("pro_warehouse_management"),
      enterprise: t("enterprise_warehouse_management"),
    },
  ];


  const cardsData = [
    {
      title: t("title1"),
      price: t("price1"),
      min: 0,
      max: 12799,
      sliding: 0,
    },
    {
      title: t("title2"),
      price: t("price2"),
      min: 12800,
      max: 22099,
      sliding: 12800,
    },
    {
      title: t("title3"),
      price: t("price3"),
      min: 22100,
      max: 31699,
      sliding: 22100,
    },
    {
      title: t("title4"),
      price: t("price4"),
      min: 31700,
      max: 41099,
      sliding: 31700,
    },
    {
      title: t("title5"),
      price: t("price5"),
      min: 41100,
      max: 49999,
      sliding: 41100,
    },
    {
      title: t("title6"),
      price: t("price6"),
      min: 50000,
      max: 59999,
      sliding: 50000,
    },
    {
      title: t("title7"),
      price: t("price7"),
      min: 60000,
      max: 68599,
      sliding: 60000,
    },
    {
      title: t("title8"),
      price: t("price8"),
      min: 68600,
      max: 77999,
      sliding: 68600,
    },
    {
      title: t("title9"),
      price: t("price9"),
      min: 78000,
      max: 86999,
      sliding: 78000,
    },
    {
      title: t("title10"),
      price: t("price10"),
      min: 87000,
      max: 96599,
      sliding: 87000,
    },
    {
      title: t("title11"),
      price: t("price11"),
      min: 96600,
      max: 100000,
      sliding: 96600,
    },
  ];

  const getSelectedPlanIndex = () => {
    if (sliderValue <= 9000) return 0;
    if (sliderValue <= 49000) return 1;
    if (sliderValue <= 69000) return 2;
    if (sliderValue <= 99000) return 3;
    return 4;
  };

  const selectedPlanIndex = getSelectedPlanIndex();
  const selectedPlan = plansData[selectedPlanIndex];


  const tableHeaders = [
    { label: "" },
    { label: "Free" },
    { label: "Plus" },
    { label: "Pro" },
    { label: "Enterprise" },
  ];

  const renderRow = (row, index, onSelect) => (
    <tr key={row.name}>
      <td style={{minWidth:"300px",position:"initial", whiteSpace:"normal",width: "auto", maxWidth: "fit-content"}}>{row.name}</td>
      <td>
        {row.basic == "include" ? (
          <Included />
        ) : row.basic == "not include" ? (
          <NotIncluded />
        ) : (
          row.basic
        )}
      </td>
      <td>
        {" "}
        {row.standard == "include" ? (
          <Included />
        ) : row.standard == "not include" ? (
          <NotIncluded />
        ) : (
          row.standard
        )}
      </td>
      <td>
        {" "}
        {row.pro == "include" ? (
          <Included />
        ) : row.pro == "not include" ? (
          <NotIncluded />
        ) : (
          row.pro
        )}
      </td>
      <td>
        {" "}
        {row.enterprise == "include" ? (
          <Included />
        ) : row.enterprise == "not include" ? (
          <NotIncluded />
        ) : (
          row.enterprise
        )}
      </td>
    </tr>
  );


  useEffect(() => {
    const index = cardsData.findIndex(
        (card) => sliderValue >= card.min && sliderValue <= card.max
    );
    const card = cardsData[index];
    if (card) {
      setCurrentPlan({
        documents: card.title,
        price: card.price,
      });
      setSelectedCard(index);
    }
  }, [sliderValue]);
  React.useEffect(
    () => {
      const translationId = localStorage.getItem("translationId");
      document.title = `${translationId?.replace(translationId
          ?.slice(translationId?.length - 3, translationId?.length),'GPT')
          ?.toUpperCase() || t("facturaGPT")} - ${t('Landing:pricing')}`;

    },[]
  )

  return (
    <div className={styles.pricingContainer}>
      <Navbar />
      <div className={styles.containerP}>
        <div className={styles.plansHeader}>
          <h1 className={styles.plansTitle}>
            {t('plansTitle')}

          </h1>
          <SubtitleTemplate
            text={
              <>
                <p>{t('subtitle1')}</p>
                <p>
                {t('subtitle2')}
                </p>
              </>
            }
          />

          <div className={styles.cardsPlansContainer}>
            <div className={styles.cardsContainer}>
              {plansData.slice(0, 2).map((plan, index) => (
                <div key={index} className={styles.card}>
                  <h3>
                    {t('plan')} <strong>{plan.title}</strong>
                  </h3>
                  <div className={styles.featuresContainer}>
                    {plan.features.map((feat) => (
                      <p>
                        <CheckCircleFeatures /> {feat}
                      </p>
                    ))}
                  </div>
                  <button
                    className={plan.buttonType && styles.customButton}
                    onClick={() =>
                      navigate(plan.buttonType ? "/contact" : "/freetrial")
                    }
                  >
                    {plan.pricing}
                    {plan.buttonType ? (
                      <ArrowDiagonalWhite />
                    ) : (
                      <ArrowDiagonalGreen />
                    )}
                  </button>
                </div>
              ))}
            </div>
            <div>
              <SubtitleTemplate
                text={
                  <>
                    <p>{t("taxesNotIncluded")}</p>
                    <p>
                    {t("cancelAnyTime")}
                    </p>
                  </>
                }
              />
            </div>
            <div className={styles.cardsContainer}>
              {plansData.slice(2, 5).map((plan, index) => (
                <div key={index} className={styles.card}>
                  <h3>
                    {t('plan')} <strong>{plan.title}</strong>
                  </h3>
                  <div className={styles.featuresContainer}>
                    {plan.features.map((feat) => (
                      <p>
                        <CheckCircleFeatures /> {feat}
                      </p>
                    ))}
                  </div>
                  <button
                    className={plan.buttonType && styles.customButton}
                    onClick={() =>
                      navigate(plan.buttonType ? "/contact" : "/freetrial")
                    }
                  >
                    {plan.pricing}
                    {plan.buttonType ? (
                      <ArrowDiagonalWhite />
                    ) : (
                      <ArrowDiagonalGreen />
                    )}
                  </button>
                </div>
              ))}
            </div>
          </div>


        </div>

        <div className={styles.parent}>
          {cardsData.map((card, index) => (
            <div className={styles.pricingCardContainer}>
              <PricingCard
                key={index}
                index={index}
                title={card.title || t('title1')}
                price={card.price || t('price1')}
                setSelectedCard={setSelectedCard}
                selectedCard={selectedCard}
                buyBtn={false}
                compareSelected={true}
                customStyles={true}
                setSliderValue={setSliderValue}
                min={card.min}
              />
            </div>
          ))}
        </div>

        <BillingSlider
          setSliderValue={setSliderValue}
          sliderValue={sliderValue}
        />
      </div>

      <div className={styles.tableBenefitsContainer}>
        <h2 className={styles.plansTitle}>
          {t('comparisonOfPlans')}
        </h2>
        <SubtitleTemplate
          stylesProp={{ maxWidth: "800px" }}
          text={
            <>
              <p>
               {t('processAnInvoice')}
              </p>
              <p>{t('doItInSeconds')}</p>
            </>
          }
        />

        <div className={styles.benefitsTable}>
          <DynamicTable
            columns={tableHeaders}
            data={benefits}
            renderRow={renderRow}
            hideCheckbox={true}
            father={"pricing"}
          />
        </div>
      </div>

      <div className={styles.trustContainer}>
        <div className={styles.googleCard}>
          <div className={styles.starsContainer}>
            <img
              className={styles.topTrustpilotStar}
              src={googleStar}
              alt="googleStar"
            />
            <img
              className={styles.topTrustpilotStar}
              src={googleStar}
              alt="googleStar"
            />
            <img
              className={styles.topTrustpilotStar}
              src={googleStar}
              alt="googleStar"
            />
            <img
              className={styles.topTrustpilotStar}
              src={googleStar}
              alt="googleStar"
            />
            <img
              className={styles.topTrustpilotStar}
              src={googleStar}
              alt="googleStar"
            />
          </div>
          <img className={styles.googleLogo} src={googleLogo} alt="google" />
        </div>
        <div className={styles.trustpilotCard}>
          <div className={styles.topContainer}>
            <img
              className={styles.topTrustpilotStar}
              src={topTrustpilotStar}
              alt="topTrustpilotStar"
            />
            Trustpilot
          </div>
          <div className={styles.bottomContainer}>
            <div className={styles.trustpilotBottomStars}>
              <div className={styles.trustStarContainer}>
                <img src={bottomTrustpilotStar} alt="bottomTrustpilotStar" />
              </div>
              <div className={styles.trustStarContainer}>
                <img src={bottomTrustpilotStar} alt="bottomTrustpilotStar" />
              </div>
              <div className={styles.trustStarContainer}>
                <img src={bottomTrustpilotStar} alt="bottomTrustpilotStar" />
              </div>
              <div className={styles.trustStarContainer}>
                <img src={bottomTrustpilotStar} alt="bottomTrustpilotStar" />
              </div>
              <div className={styles.trustStarContainer}>
                <img src={bottomTrustpilotStar} alt="bottomTrustpilotStar" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <SubtitleTemplate
        stylesProp={{ maxWidth: "800px" }}
        text={t('writeAReview')}
      />

      <h1 className={styles.reviewsTitle}>{t('JoinUsToday')}</h1>
      <SubtitleTemplate
        stylesProp={{ maxWidth: "800px" }}
        text={t('oneStepCloser')}
      />

      <a href="/freetrial" className={styles.startButton}>
        {t('freeTrial')} <img src={diagonalArrow} />
      </a>

      <CookiePopup />
      <FooterLanding/>

    </div>
  );
};

export default Pricing;
